import { useEffect, useRef, useState } from "react";
import { BLOCKED_AFTER_MS } from "../hooks/useAutoplayBlocked";

/**
 * The browser blocked the start: either play() was refused (the player calls `setBlocked(true)`), or a player that
 * should sound (`armed`: loaded, wanted, not playing, not ended, not failed) stays silent BLOCKED_AFTER_MS past
 * `extraDelayMs()` (a cast's scheduled start). `resetKey` restarts the wait (new media, a new timeline).
 */
export function useBlocked(armed: boolean, resetKey: unknown, extraDelayMs?: () => number) {
  const [blocked, setBlocked] = useState(false);
  const extra = useRef(extraDelayMs);
  extra.current = extraDelayMs;
  useEffect(() => {
    setBlocked(false);
    if (!armed) return;
    const id = setTimeout(() => setBlocked(true), BLOCKED_AFTER_MS + (extra.current?.() ?? 0));
    return () => clearTimeout(id);
  }, [armed, resetKey]);
  return [blocked, setBlocked] as const;
}
